var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C12.3809 3 12.7281 3.21564 12.893 3.55468L15.097 8.08485L20.1413 8.75478C20.5188 8.80492 20.8338 9.06433 20.9515 9.42205C21.0692 9.77978 20.9688 10.1725 20.6932 10.4321L17.0111 13.9019L17.9246 18.8461C17.993 19.2161 17.8405 19.5921 17.5323 19.8132C17.2242 20.0342 16.8149 20.0613 16.4797 19.8827L12 17.497L7.52034 19.8827C7.18508 20.0613 6.77585 20.0342 6.46768 19.8132C6.15952 19.5921 6.007 19.2161 6.07537 18.8461L6.98889 13.9019L3.30679 10.4321C3.03122 10.1725 2.93081 9.77978 3.04852 9.42205C3.16623 9.06433 3.48121 8.80492 3.85872 8.75478L8.90297 8.08485L11.107 3.55468C11.2719 3.21564 11.6191 3 12 3ZM12 6.23756L10.4577 9.40775C10.3132 9.70462 10.0272 9.9098 9.69668 9.9537L6.16674 10.4225L8.74346 12.8506C8.98475 13.078 9.09399 13.41 9.03413 13.734L8.39485 17.1939L11.5297 15.5244C11.8232 15.368 12.1768 15.368 12.4703 15.5244L15.6052 17.1939L14.9659 13.734C14.906 13.41 15.0153 13.078 15.2565 12.8506L17.8333 10.4225L14.3033 9.9537C13.9728 9.9098 13.6868 9.70462 13.5423 9.40775L12 6.23756Z",
    fill: "#575656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToFavorite);
export default __webpack_public_path__ + "static/media/addToFavorite.f1260b5e68493f2ed6b11efab37e8879.svg";
export { ForwardRef as ReactComponent };